import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { GooglePlaceModule } from "ngx-google-places-autocomplete";

import { IonicModule } from '@ionic/angular';

import { BusinessLocationsPage } from './business-locations.page';

const routes: Routes = [
  {
    path: '',
    component: BusinessLocationsPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    GooglePlaceModule,
    RouterModule.forChild(routes)
  ],
  declarations: [BusinessLocationsPage]
})
export class BusinessLocationsPageModule {}
